import { render, staticRenderFns } from "./OnlineAnswerCount.vue?vue&type=template&id=1be1d3cc&scoped=true&"
import script from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"
export * from "./OnlineAnswerCount.vue?vue&type=script&lang=js&"
import style0 from "./OnlineAnswerCount.vue?vue&type=style&index=0&id=1be1d3cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be1d3cc",
  null
  
)

export default component.exports